import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function RealProof() {
  const proofs = [{
    image: 'https://cdn.magicpatterns.com/uploads/3wGfYEnMn6acWRnqELcRzZ/WhatsApp_Image_2026-05-25_at_19.51.01_(2).jpg',
    name: 'Luciana · Mendoza',
    rotation: '-rotate-1'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/cGspMtF91g2d5gRLgcUce5/WhatsApp_Image_2026-05-25_at_19.51.01_(1).jpg',
    name: 'Gabriela · Buenos Aires',
    rotation: 'rotate-1'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/nWWUEvVVz5YYPCgHkPoMsM/WhatsApp_Image_2026-05-25_at_19.51.01.jpg',
    name: 'Mariela · Rosario',
    rotation: '-rotate-1'
  }];
  return <section className="w-full bg-[#FAF0DE] py-4 md:py-8 relative" data-id="element-265">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-266">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-267">
          <div className="text-center mb-4 md:mb-6" data-id="element-268">
            <div className="inline-flex items-center gap-2 bg-[#FDE4CE] text-[#B45309] font-bold text-xs md:text-sm tracking-wider px-3 py-1 rounded-full mb-2" data-id="element-269">
              <MessageCircleIcon className="w-4 h-4" data-id="element-270" />
              PRUEBAS REALES
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-[#3D2817] mb-1 md:mb-2 leading-tight" data-id="element-271">
              📱 Esto es lo que nos llega cada semana
            </h2>
            <p className="text-sm md:text-base text-[#6B5747] max-w-2xl mx-auto" data-id="element-272">
              Mensajes reales de personas que ya están fabricando y vendiendo
              sus propios sahumerios. Sin filtros, sin actores, sin marketing
              inflado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto" data-id="element-273">
            {proofs.map((proof, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            y: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.5
          }} whileHover={{
            scale: 1.03,
            rotate: 0
          }} className={`bg-white border border-[#E8D5BA] rounded-lg p-2 md:p-3 shadow-md hover:shadow-xl transition-all ${proof.rotation}`} data-id="element-274">
                <div className="overflow-hidden rounded-md bg-[#1a1a1a] mb-2" data-id="element-275">
                  <img src={proof.image} alt={`Captura real de WhatsApp — ${proof.name}`} className="w-full h-auto object-cover" loading="lazy" data-id="element-276" />
                </div>
                <p className="text-[#9B8770] text-xs font-semibold text-center pb-1" data-id="element-277">
                  — {proof.name}
                </p>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="text-center text-sm md:text-base text-[#6B5747] mt-4 md:mt-6 italic max-w-2xl mx-auto" data-id="element-278">
            👉 Capturas enviadas por nuestras clientas. Tu nombre puede estar
            acá la semana que viene.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}